import React, { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Tailwind port of truss-website MarketingCard styling for onboarding sections. */
export const onboardingSectionCardClass = cn(
  'relative rounded-[14px] border border-border bg-card overflow-hidden',
  'shadow-[0_1px_2px_rgba(15,23,42,0.05),0_4px_12px_rgba(15,23,42,0.04)]',
  'transition-[border-color,box-shadow,transform] duration-200',
  'before:absolute before:inset-x-0 before:top-0 before:h-[3px]',
  'before:bg-gradient-to-r before:from-primary before:to-[#FFC400] before:opacity-0',
  'hover:border-border hover:shadow-[0_4px_6px_-1px_rgba(15,23,42,0.07),0_12px_20px_-8px_rgba(0,119,204,0.12)]',
  'hover:-translate-y-0.5 hover:before:opacity-100',
  'motion-reduce:hover:translate-y-0 motion-reduce:transition-none'
);

/** truss-website CapabilityMosaic / IntentRamps CardTitle */
export const marketingCardTitleClass =
  'text-[1.0625rem] font-extrabold tracking-[-0.02em] text-foreground mb-[0.45rem]';

/** truss-website CapabilityMosaic / IntentRamps CardBody */
export const marketingCardBodyClass =
  'text-[0.9375rem] text-muted-foreground leading-[1.55]';

/** Stronger hover affordance for interactive billing/marketing cards. */
export const marketingSectionCardHoverClass = cn(
  'hover:ring-2 hover:ring-primary/40 hover:border-primary/30',
  'focus-within:ring-2 focus-within:ring-primary/40 focus-within:border-primary/30'
);

interface MarketingSectionCardProps {
  children: ReactNode;
  className?: string;
  highlighted?: boolean;
  interactive?: boolean;
  'data-tutorial'?: string;
}

/** Shared marketing card shell used across onboarding and billing pages. */
export function MarketingSectionCard({
  children,
  className,
  highlighted = false,
  interactive = true,
  'data-tutorial': dataTutorial,
}: MarketingSectionCardProps) {
  return (
    <div
      data-tutorial={dataTutorial}
      className={cn(
        onboardingSectionCardClass,
        interactive && marketingSectionCardHoverClass,
        'flex flex-col',
        highlighted && 'ring-2 ring-primary before:opacity-100',
        className
      )}
    >
      <div className="flex flex-col flex-1 p-6">{children}</div>
    </div>
  );
}
